<template>
    <div class="container-fluid reports-tab-nav employee-table-wrapper">


        <div class="row no-gutters py-2 mb-3">
            <div class="col-sm-6 pl-0">
                <div class="company-form-box-title custom-search">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-6 cursor-pointer text-right company-form-box-title pr-0">
                <b-button id="show-btn" v-if="ce" @click="addNew()">+ Add New Role</b-button>
            </div>
        </div>


        <table class="table dataTable">
            <thead>
                <tr class="table-head">
                    <td>Name</td>
                    <td class="">Action</td>
                </tr>
            </thead>
            <tbody>
                <tr class="hover-bg table-row border-bottom mx-2" v-for="(role , n) in paginatedData" :key="role.id">
                    <td class="col-md-5 align-middle list-columns">{{role.name}} <span v-if="role.is_default != 0">(default)</span></td>

                    <td class="clearfix col-md-6 align-middle" >
                        <div class="float-right mr-2 position-relative" >
                            <b-button-toolbar>
                                <!-- Abdullah26 added px-1 and text-left  -->
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu px-1" aria-labelledby="actionDropdown">
                                    <b-button-group class="mr-0" v-if="role.is_default == 0" >
                                        <b-button class="mr-3 rounded edit-btn text-left" title="Edit Role" @click="editRole(role.id)" >
                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                        </b-button>

                                        <b-button class="mr-3 rounded edit-btn text-left" title="Role Resources" @click="roleResources(role.id , role.name , false)">
                                            <b-icon icon="layers" class="mr-2" aria-hidden="true" ></b-icon>Resources
                                        </b-button>
                                    </b-button-group>
                                    <b-button-group class="mr-0" v-else >
                                        <!-- alpha fix chnaged title  -->
                                        <b-button class="mr-3 rounded edit-btn text-left" title="Resources" @click="roleResources(role.id , role.name , true)">
                                            <b-icon icon="layers" class="mr-2" aria-hidden="true" title="Default"></b-icon>Resources
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Mustafijur: 17-05-2026: Starts -->
        <div>
            <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                                @change="setFirstPage()"></b-form-select></li>
                        <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                    </ul>
                    <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                        :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                        first-number last-number></b-pagination-nav>
                </div>

            </div>
            <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                <span class="d-block text-center">{{ blankmsg }}</span>
                <img v-if="showoverlay" v-bind:src="$api_url + '/images/download-loader.svg'" class="loader-logo"
                    width="100px" />
            </div>
        </div>

        <!-- <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
        <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav></div> -->
        <!-- Mustafijur: 17-05-2026: Ends -->



        <!-- Abdullah26 maked title dynamic  -->
        <b-modal id="bv-modal-role" size="lg" hide-footer :title="role_modal" v-if="this.ce">
            <b-overlay :show="showoverlay" rounded="sm">
                <b-form @submit.stop.prevent="onSubmit">
                    <div class="clearfix">
                        <div class="px-3">
                            <input type="hidden" v-model="fdata.id" name="id">

                            <b-form-group id="name-group" label="Role Name" class="required-field" label-for="name">
                                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Role Name"></b-form-input>
                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <label style="opacity: 0;">label</label>
                            <div class="text-center">
                                <!-- Abdullah26 maked btn varient primary and remove inline style and removed variant="light"  -->
                                 <!-- alpha fix- changed btn text to update  -->
                                <b-button v-if="fdata.id > 0" type="submit" variant="primary">Update</b-button>
                                <b-button class="btn-primary" v-else type="submit" variant="primary">Submit</b-button>
                            </div>

                        </div>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-role-resource" size="lg" hide-footer :title="'Role Resource for ' + role_title">
            <role-resource :role_id="this.role_id"  :disabled="disabled"></role-resource>
        </b-modal>


    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: [ ],
        data(){

            return {

                roles:[],
                fdata: {name:null , id:null},
                rdata: {name:null , id:null},
                showoverlay:false,
                showoverlay_list:false,


                role_title : '',
                role_id : null,

                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},

                ce : true,
                disabled : false,

                // Mustafijur: 17-05-2026: Starts
                temp_length: 20,
                people: 0,
                length: 20,
                length_options: [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
                blankmsg : 'Fetching data..',

                role_modal : 'Add Role',
                // Mustafijur: 17-05-2026: Ends
            }
        },
        methods:{


            addNew(x)
            {
                this.addtype = x;
                this.resetForm();
                this.role_modal = 'Add Role';
                this.$bvModal.show('bv-modal-role');

            },
            getRoleData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/role/company' , {
                    params: {

                    }
                }).then(function(response){
                    this.roles = response.data;

                }.bind(this)).catch(function (error){
                    //currentObj.serverError(error);
                    });
            },
            editRole:function(x)
            {
                this.addtype = false;
                if(!this.checkNet()) return false;
                let currentObj = this;
                // alpha fix- amaked it update
                this.role_modal = 'Update Role';
                this.showoverlay = true;
                axios.get(this.$api_url+'/acl/role/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.$validator.reset();
                    this.showoverlay = false;
                    this.$bvModal.show('bv-modal-role');
                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            roleResources:function(x , role_title , disabled)
            {
                if(!this.checkNet()) return false;

                this.role_title = role_title;
                this.role_id = x;
                this.disabled = disabled;
                this.$bvModal.show('bv-modal-role-resource');

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {name:null, id:null};

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/acl/role/company', formData)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    this.getRoleData();


                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    this.resetForm();
                                    //this.movenext = true;
                                    //this.showMessage();
                                    this.$bvModal.hide('bv-modal-role');

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });
                });
            },

        },
        created: function(){
            this.getRoleData();
            Fire.$on('reloadUsers', () => {this.getRoleData()});
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.roles;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                this.people = this.filteredData.length; // Mustafijur: 17-05-2026
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
